import React from 'react';
import ReactDOM from 'react-dom';
import './Footer.css';

class Footer extends React.Component {
  render (){
    return (
      <footer id="contact" class="container-fluid bg-4 text-center">
        <div class="container text-center">
          <h3 class="contactme">Contact me</h3>

          <div class="row">
            <div class="col-sm-4">
              <span class="glyphicon glyphicon-earphone iconLarge bluec"></span><br /><p class="sitation">Phone: +33 6 65 20 29 27 </p><br />
              <span class="glyphicon glyphicon-envelope iconLarge bluec"></span><br /><a href="mailto:salmanfarhat098@gmail.com" class="sitation" target="blacked" >Email: salmanfarhat098@gmail.com</a><br />
            </div>
            <div class="col-sm-4">
              <span class="glyphicon glyphicon-globe iconLarge bluec"></span><br /><a href="https://www.google.com/maps/place/Grenoble/@45.1841602,5.680523,13z/data=!4m13!1m7!3m6!1s0x478af48bd689be6f:0x618c10cd6e995398!2sGrenoble!3b1!8m2!3d45.188529!4d5.724524!3m4!1s0x478af48bd689be6f:0x618c10cd6e995398!8m2!3d45.188529!4d5.724524" class="sitation" target="blacked" >Address: Grenoble, France</a><br />
              <span class="glyphicon glyphicon-user iconLarge bluec specific"></span><br /><p class="sitation">I love to help, if I can help you, just email me.</p><br />
            </div>
            <div class="col-sm-4">
              <i class="fa fa-linkedin iconLarge bluec"></i> <br /><a href="https://www.linkedin.com/in/salman-farhat-b854b6181/" class="sitation" target="blacked" >Linkedin Salman</a><br />
              <i class="fa fa-github specific iconLarge bluec"></i> <br /><a href="https://github.com/salmanfarhat1" class="sitation" target="blacked" >github salman</a><br />
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer;
